/**
 * Re-export from routing for backwards compatibility
 */
import {
  locales as routingLocales,
  type Locale as LocaleType,
} from "./routing";

export { locales, defaultLocale, type Locale } from "./routing";

/**
 * Locale display names for UI
 */
export const localeNames: Record<string, string> = {
  en: "English",
  af: "Afrikaans",
};

/**
 * Check if a given string is a valid locale
 */
export function isValidLocale(locale: string): locale is LocaleType {
  return routingLocales.includes(locale as LocaleType);
}
